module.exports = __webpack_public_path__ + "static/media/simonSound3.f3c18b98.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simonSound3.mp3
// module id = 204
// module chunks = 0